var DialogManager = require('./dialog/manager');

module.exports = {
  // Public: Dismiss the currently opened dialog.
  //
  // Returns Nothing.
  dismiss: function() {
    DialogManager.getInstance().dismiss();
  },

  // Public: Present a dialog using the content view model.
  //
  // content - ViewModel
  //
  // Returns Nothing.
  presentDialog: function(content) {
    DialogManager.getInstance().presentDialog(content);
  }
};
